import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Box, Button, Container, Grid } from '../../../components/mui/Core/index'
import GenericNav from '../../../components/genericcomponents/navbars/GenericNav'
import { displayReports, searchReports } from '../../../api/reporting/display-reports'
import GenericSnackbar from '../../../components/GenericSnackbar/generic-snackbar'
import useBrowserTabTitles from '../../../hooks/browserTabTitles/browser-tab-titles'
import AdHocReportModal from './components/AdHocReportingModal/adhoc-report-modal'
import { adHocReportingConstants } from '../../../constants/ad-hoc-reporting'
import { useTheme } from '../../../components/mui/Styles/index'
import { setSnackbar } from '../../../components/GenericSnackbar/generic-snackbar-slice'
import PageTitle from '../../../components/PageTitle/page-title'
import DateRangeSearch from '../../../components/DateRangeSearch/date-range-search'
import ReportsTable from './components/ReportsTable/reports-table'
import { sessionStorageKeyConstants } from '../../../constants/session-storage-key-constants'

function DisplayReports() {
  const dispatch = useDispatch()
  const theme = useTheme()
  const [reports, setReports] = useState([])
  const [searchedDates, setSearchedDates] = useState({
    startDate: '',
    endDate: '',
  })
  const [isFetchingReports, setIsFetchingReports] = useState(true)
  const [openAdHocModal, setOpenAdHocModal] = useState(false)
  const selectedClient = JSON.parse(
    sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_CLIENT),
  )
  const { state } = useLocation()
  const reportTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${state.reportTitle}`
    : state.reportTitle
  const orderBy = state.orderBy
  const category = state.category
  const cognosReportingUrl = state.cognosReportingUrl
  useBrowserTabTitles(reportTitle)

  useEffect(() => {
    displayReports(orderBy, category)
      .then((response) => {
        if (response?.data?.data) {
          setReports(response.data.data)
        }
      })
      .catch((exception) => {
        dispatch(
          setSnackbar({
            message: exception?.message,
            severity: 'error',
            action: true,
          }),
        )
      })
      .finally(() => {
        setIsFetchingReports(false)
      })
  }, [category, orderBy, dispatch])

  const returnSearch = (returnStartDate, returnEndDate) => {
    setSearchedDates({ startDate: returnStartDate, endDate: returnEndDate })
    setIsFetchingReports(true)
    searchReports(orderBy, category, returnStartDate, returnEndDate, setReports)
      .then((response) => {
        if (response?.data?.data) {
          setReports(response.data.data)
        }
      })
      .catch((exception) => {
        dispatch(
          setSnackbar({
            message: exception?.message,
            severity: 'error',
            action: true,
          }),
        )
      })
      .finally(() => {
        setIsFetchingReports(false)
      })
  }

  const toggleAdHocModal = () => {
    setOpenAdHocModal(!openAdHocModal)
  }

  const handleRedirectToAdHocReport = () => {
    setOpenAdHocModal(true)
  }

  const adHocButtonWrapper = {
    marginTop: '15px',
  }

  const adHocModalStyle = {
    letterSpacing: '1.28px',
    padding: theme.spacing(0, 6),
  }

  const searchWrapper = {
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'flex-end',
    marginTop: '15px',
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <GenericNav selected='Reports' user='authenticated' />
      <Container maxWidth='xl'>
        <Grid container>
          <Grid size={{ xs: 12 }}>
            <PageTitle title={reportTitle} />
          </Grid>
          <Grid size={{ xs: 6 }}>
            {cognosReportingUrl && (
              <Box sx={adHocButtonWrapper}>
                <Button
                  onClick={handleRedirectToAdHocReport}
                  sx={adHocModalStyle}
                  variant='contained'
                  color='secondary'
                >
                  {adHocReportingConstants.title.ADHOC_REPORTING_BUTTON}
                </Button>
              </Box>
            )}
            {openAdHocModal && (
              <AdHocReportModal
                reportingRedirectUrl={cognosReportingUrl}
                toggleModal={toggleAdHocModal}
              />
            )}
          </Grid>
          <Grid size={{ xs: 6 }} sx={searchWrapper}>
            <DateRangeSearch returnSearch={returnSearch} />
          </Grid>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <ReportsTable
            reports={reports}
            isFetchingReports={isFetchingReports}
            searchedDates={searchedDates}
          />
        </Grid>
      </Container>
      <GenericSnackbar />
    </Box>
  )
}

export default DisplayReports
